import { defineComponent as _defineComponent } from 'vue'
import { useFloorsStore, useFloorplansStore, useLocationsStore, useUsersStore } from '@/stores'
import { t } from '@/plugins/i18n';
import router from "@/service/router";
import AppHeader from '@/components/AppHeader/AppHeader.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NoFloorplan',
  setup(__props) {

const floors = useFloorsStore()
const floorplans = useFloorplansStore()
const locationsStore = useLocationsStore();
const usersStore = useUsersStore();

function addFloor() {
  router.push(`/new-floor-plan`);
}


return { __sfc: true,floors, floorplans, locationsStore, usersStore, addFloor, t, AppHeader }
}

})